import ChatPanelRuntime from 'components/Chat/ChatPanelRuntime';
import useInstructorSubmissionChat from 'hooks/chat/useInstructorSubmissionChat';

const InstructorSubmissionChatPanel = ({ currentSubmission, isOpen }) => {
    const {
        chat,
        fileKey,
        hasOlderMessages,
        isBootstrapping,
        isLoadingOlderMessages,
        loadOlderMessages,
        onChatRequestStateChange,
        showSuggestions,
        suggestions,
        viewModel,
    } = useInstructorSubmissionChat({
        currentSubmission,
        isOpen,
    });

    const chatPanelProps = {
        chat,
        fileKey,
        hasOlderMessages,
        hideBackButton: true,
        hideComposer: true,
        isBootstrapping,
        isLoadingOlderMessages,
        isOpen,
        onChatRequestStateChange,
        onLoadOlderMessages: loadOlderMessages,
        showSuggestions,
        suggestions,
        viewModel,
    };

    return <ChatPanelRuntime {...chatPanelProps} />;
};

export default InstructorSubmissionChatPanel;
